import { Component, OnInit, AfterViewInit, OnChanges, ViewChild, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { MatPaginator, MatSort, MatDialog } from '@angular/material';
import { CustomDataSource } from 'path-shared/services/datasource/custom.datasource';
import { FilterService } from 'path-shared/services/filter/filter.service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DownloadExcelDialogComponent } from 'path-shared/components/dialogs/download-excel-dialog/download-excel-dialog.component';
import { Builder } from 'path-shared/models/builder';
import { MotiuNoNotificacio } from '../../models/motius-notificacio.model';
import { MotiusNoNotificacioFilter } from '../../models/motius-notificacio-filter';
import { MotiusNoNotificacioService } from '../../services/motius-notificacio.service';
import { MotiusNoNotificacioFilterService } from '../../services/motius-notificacio-filter.service';


@Component({
  selector: 'app-motius-notificacio-table',
  templateUrl: './motius-notificacio-table.component.html',
  styleUrls: ['./motius-notificacio-table.component.scss']
})
export class MotiusNoNotificacioTableComponent implements OnInit, AfterViewInit, OnChanges {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  data: MotiuNoNotificacio[];
  dataSource: CustomDataSource<MotiuNoNotificacio, MotiusNoNotificacioFilter>;
  filter: MotiusNoNotificacioFilter = new MotiusNoNotificacioFilter('somId', 'asc');
  displayedItems = [];
  highlightedRows = [];

  @Input() selectButton: boolean;
  @Input() updatedFilterData: MotiusNoNotificacioFilter;
  @Output() notify: EventEmitter<number> = new EventEmitter<number>();
  @Output() itemClicked: EventEmitter<string> = new EventEmitter<string>();
  @Output() itemSelected: EventEmitter<string> = new EventEmitter<string>();

  displayedColumns = ['somId', 'descripcio'];

  constructor(
    private motiusNoNotificacioService: MotiusNoNotificacioService,
    private filterService: FilterService,
    private dialog: MatDialog,
    private i18n: I18n
  ) {
  }

  ngOnInit() {
    this.sort.disableClear = true;
    this.dataSource = CustomDataSource.create<MotiuNoNotificacio, MotiusNoNotificacioFilter>(this.paginator, new MotiusNoNotificacioFilterService(), 'urlGetMotiusNoNotificacio', 'urlGetMotiusNoNotifcacioCount');
    this.dataSource.subject.subscribe((data) => {
      data.forEach(item => {
        this.displayedItems[item.secureId] = {
          id: item.secureId
        };
      });
    });

    this.filter.filterUpdated.subscribe(updated => {
      if (updated) {
        this.load();
        if (!this.selectButton) { this.filterService.saveFilter('motius-notificacio-filter', this.filter); }
      }
    });

    if (!this.selectButton) { this.filterService.loadFilter('motius-notificacio-filter', this.filter); }
    this.filter.paginator.init(this.sort, this.paginator);
  }

  ngAfterViewInit() {
    // reset the paginator after sorting
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.filter.paginator.set(this.sort, this.paginator);
      this.filter.updated();
    });

    merge(this.sort.sortChange, this.paginator.page)
    .pipe(tap(() => this.filter.updated()))
    .subscribe();

    this.load();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.updatedFilterData != null) {
      this.update();
    }
  }

  update() {
    if (this.dataSource !== undefined) {
      this.updatedFilterData.paginator.set(this.sort, this.paginator);
      this.dataSource.loadFilter(this.updatedFilterData);
    }
  }

  load() {
    this.filter.paginator.set(this.sort, this.paginator);
    this.dataSource.loadFilter(this.filter);
  }

  onRowClicked(row) {
    this.itemClicked.next(row.secureId);
  }

  generateExcel(): void {
    let filter = this.filter;
    if (this.updatedFilterData != null) {
      filter = this.updatedFilterData;
    }
    this.dialog.open(DownloadExcelDialogComponent, {
        closeOnNavigation: false,
        autoFocus: true,
        data: Builder.newDownloadExcelDialogData (this.motiusNoNotificacioService, filter, this.i18n('Motivos no notificación'), this.sort.direction, this.sort.active)
    });
  }

}
